export const FETCH_TRANSACTION = "FETCH_TRANSACTION";
export const FETCH_GATEWAY = "FETCH_GATEWAY";
export const SEND_PAYIN_PROOF = "SEND_PAYIN_PROOF";
export const CANCEL_TRANSACTION = "CANCEL_TRANSACTION";
// export const CHANGE_LOADING_STATUS = "CHANGE_LOADING_STATUS";

